import React, { Fragment } from "react";
import { publicRequest } from "../auth/requestMethods";
import SweetAlert from "sweetalert2";
import { Progress } from "reactstrap";
import { useLocation } from "react-router-dom";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const ResetPwd = ({ history }) => {
  const [error, setError] = React.useState("");
  const [password, setPassword] = React.useState({ 1: "", 2: "" });
  const [loading, setLoading] = React.useState(false);
  const [secondPassEye, setSecondEye] = React.useState(false);
  const [firstEye, setFirstEye] = React.useState(false);

  const path = useLocation().pathname.split("/")[2];
  const [passwordMeter, setPasswordMeter] = React.useState({
    text: "Weak",
    percent: 1,
    class: "danger",
  });

  function passwordOnChange(e) {
    checkStrength(e.target.value);
    setPassword({ ...password, [e.target.name]: e.target.value });
  }

  function checkStrength(password) {
    let percent = 0;

    //If password contains both lower and uppercase characters
    if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) percent += 25;
    //If it has numbers and characters
    if (password.match(/([0-9])/)) percent += 25;
    //If it has one special character
    if (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) percent += 20;
    //If password is greater than 7
    if (password.length > 7) percent += 30;

    if (percent < 60)
      setPasswordMeter({
        text: "Weak",
        percent,
        class: "danger",
      });
    else if (percent < 100)
      setPasswordMeter({
        text: "Medium",
        percent: 60,
        class: "warning",
      });
    else if (percent === 100)
      setPasswordMeter({
        text: "Strong",
        percent,
        class: "success",
      });
  }

  function formSubmit(e) {
    e.preventDefault();
    // submit
    error && setError("");
    setLoading(true);
    publicRequest()
      .post(`/users/verify-email/${path}`, { password: password[1] })
      .then((res) => {
        SweetAlert.fire({
          title: "Successful!",
          text: "Email has been activated! You will be redirected to login.",
          icon: "success",
        })
          .then(() => {
            history.push(`${process.env.PUBLIC_URL}/login`);
          })
          .catch(() => history.push(`${process.env.PUBLIC_URL}/login`));
      })
      .catch(({ response }) => {
        console.log(response.data);
        setError(response.data.message);
        setLoading(false);
      });
    // submit
  }

  return (
    <Fragment>
      <div className="page-wrapper">
        <div className="container-fluid">
          <div className="authentication-main">
            <div className="row">
              <div className="col-md-12 p-0">
                <div className="auth-innerright">
                  <div className="authentication-box">
                    <div className="text-center">
                      {/* <img src={`${process.env.PUBLIC_URL}/full-logo.jpg`} alt="" width={200} /> */}
                    </div>
                    <div className="card mt-4 p-4">
                      <form className="theme-form" onSubmit={formSubmit}>
                        <h5 className="f-16 mb-3 f-w-600">Activate Account</h5>
                        <div
                          className="form-group"
                          style={{ position: "relative" }}
                        >
                          <label className="col-form-label">*Password</label>
                          <input
                            className="form-control"
                            type={firstEye ? "password" : "text"}
                            placeholder="*****"
                            value={password["1"]}
                            onChange={passwordOnChange}
                            name="1"
                          />
                          {firstEye ? (
                            <VisibilityOffIcon
                              style={{
                                position: "absolute",
                                top: "60%",
                                right: "4%",
                                cursor: "pointer",
                                color: "lightgray",
                              }}
                              onClick={() => {
                                setFirstEye((val) => !val);
                              }}
                            />
                          ) : (
                            <RemoveRedEyeIcon
                              style={{
                                position: "absolute",
                                top: "60%",
                                right: "4%",
                                cursor: "pointer",
                                color: "lightgray",
                              }}
                              onClick={() => {
                                setFirstEye((val) => !val);
                              }}
                            />
                          )}
                        </div>
                        <div
                          className="form-group"
                          style={{ position: "relative" }}
                        >
                          <label className="col-form-label">
                            *Confirm Password
                          </label>
                          <input
                            className="form-control"
                            type={secondPassEye ? "password" : "text"}
                            placeholder="*****"
                            value={password["2"]}
                            onChange={passwordOnChange}
                            name="2"
                          />
                          {secondPassEye ? (
                            <VisibilityOffIcon
                            onClick={() => {
                              setSecondEye((val) => !val);
                            }}
                            style={{
                              position: "absolute",
                              top: "60%",
                              right: "4%",
                              cursor: "pointer",
                              color: "lightgray",
                            }}
                            />
                            ) : (
                            <RemoveRedEyeIcon
                              onClick={() => {
                                setSecondEye((val) => !val);
                              }}
                              style={{
                                position: "absolute",
                                top: "60%",
                                right: "4%",
                                cursor: "pointer",
                                color: "lightgray",
                              }}
                            />
                          )}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <Progress
                            className="col-md-8"
                            color={passwordMeter.class}
                            value={passwordMeter.percent}
                          />
                          <p
                            className={`col-form-label txt-${passwordMeter.class}`}
                          >{`${passwordMeter.text}`}</p>
                        </div>
                        <p className="col-form-label mb-2 txt-info">
                          Minimum of 7 characters, at least one upper case, at least one special character
                        </p>
                        <div className="form-group form-row mb-0">
                          {loading && (
                            <div className="loader d-flex justify-content-center mb-4">
                              <div className="line bg-primary"></div>
                              <div className="line bg-primary"></div>
                              <div className="line bg-primary"></div>
                              <div className="line bg-primary"></div>
                            </div>
                          )}
                          <div className="col-md-2">
                            <button
                              disabled={
                                password["1"].length >= 7
                                  ? password["1"] === password["2"]
                                    ? false
                                    : true
                                  : true
                              }
                              className="btn btn-primary"
                              type="submit"
                            >
                              Activate
                            </button>
                          </div>
                        </div>
                      </form>
                      {error && (
                        <p className="btn-danger text-center my-2 py-2">
                          {error}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- Reset Password page end--> */}
        </div>
      </div>
    </Fragment>
  );
};

export default ResetPwd;
